<template>
  <div id="storeDetails">
    <div id="storeName">
      {{ store.name }}
    </div>

    <a v-if="!!store.address || !!store.city" @click="openGoogleMap(store)">
      {{ store.address }}<span v-if="store.city">, {{ store.city }} </span>
    </a>

    <a v-if="!!store.phoneNumber" :href="`tel:${store.phoneNumber}`" @click="">
      {{ store.phoneNumber | phone }} <br/>
    </a>

    <div style="margin: 20px auto 10px;">
      <open-close-chip :store="store" />
    </div>

    <div v-if="openUntil" id="openUntilDetails">
      {{ openUntil }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStoreHoursMassaged, getStoreOpenAndClose, isBeforeOpen } from "@/services/util.service"

import OpenCloseChip from "@/components/OpenCloseChip"


export default {
  props: {
    store: {
      type: Object,
      required: true
    }
  },

  components: { OpenCloseChip },

  computed: {
    openUntil() {
      const dt = new Date()
      dt.setHours(0)
      dt.setMinutes(0)
      dt.setSeconds(0)
      let lang = this.$vuetify.lang.current
      let open = ''
      let until = ''
      let at = ''
      let extraText = ''
      let isTomorrow = false;
      switch(lang){
        case 'en': 
          until = 'Until';
          open = 'Open';
          at = 'at'
          extraText = 'tomorrow'
          break;
        case 'fr': 
          until = 'jusqu\'à';
          open = 'Ouvre';
          at = 'à'
          extraText = 'demain'
          break;
        case 'es': 
          until = 'Hasta';
          open = 'Abierto';
          at = 'a'
          extraText = 'mañana'
          break;
        case 'ko': 
          until = '까지';
          open = '열림';
          at = '에'
          extraText = '내일'
          break;
        case 'zh':
          until = '直到';
          open = '开放';
          at = '在'
          extraText = '明天'
          break;
        case 'zh-TW':
          until = '直到'
          open = '开放'
          at = '在';
          extraText = '明天';
          break;
        default: 
          until = 'Until';
          open = 'Open';
          at = 'at'
          extraText = 'tomorrow'
      }

      if (this.testStore(this.store)) {
        const todaysHours = getStoreHoursMassaged(this.store)[dt.getDay()]
        return !!todaysHours && todaysHours.close ? `${open} ${until} ${todaysHours.close}` : null
      } else {
        // When past todays open, grab tomorrows opening hours
        if (!isBeforeOpen(this.store)) {
          dt.setDate(dt.getDate() + 1)
          isTomorrow = true
        }

        const nextHours = getStoreHoursMassaged(this.store)[dt.getDay()]
        const { open: openTomorrow } = getStoreOpenAndClose(this.store, dt)

        if (openTomorrow !== undefined) {
          // Just show 12am here instead of "Open 24 hours"
          const openText = !extraText || openTomorrow !== 0 ? nextHours.open : '12am'
          if (isTomorrow) {
            return !!nextHours && nextHours.open ? `${open}s ${extraText} ${at} ${openText}` : null
          } else {
            return !!nextHours && nextHours.open ? `${open}s ${at} ${openText}` : null
          }
  
        } else {
          return null
        }
      }
    },

    ...mapGetters([ 'testStore' ])
  },

  methods: {
    openGoogleMap(item) {
      const urlSuffix = item["address"] + ", " + item["city"] + ", " + item["postalCode"]

      window.open("https://www.google.com/maps/search/?api=1&query="+urlSuffix, "_blank")
    }
  }
}
</script>

<style>
  /* Use slightly less screen size on mobile */
  @media only screen and (max-width: 920px) {
    #storeName {
      font-size: calc(var(--text-size-3) * 0.85) !important;
    }
    #storeDetails, #openUntilDetails {
      font-size: var(--text-size-1) !important;
    }
    #mainLogoImage {
      height: 20vh !important;
      margin-top: 5vh !important;
    }
  }
</style>
<style scoped>
  #storeName {
    font-weight: 700;
  }
  #storeDetails, #openUntilDetails {
    font-size: calc(var(--text-size-1) * 1.2);
    /* font-weight: 600; */
  }
  #storeDetails {
    font-weight: 600;
  }
  #openUntilDetails {
    font-weight: 500;
  }

  #storeDetails a {
    color: #2c3e50;

    display: block !important;
    text-decoration: underline !important;
    margin: 5px auto;
  }
</style>